import React from 'react';
import { BooleanInput, Create, DateInput, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';

const CookSubscriptionV3Create = (props: any) => {
    return (
        <Create {...props}>
            <SimpleForm>
                <BooleanInput source="active"/>
                <TextInput source='cookId' />
                <ReferenceInput label="Subscription" source="subscriptionId" reference="SubscriptionV3">
                    <SelectInput optionText='id' />
                </ReferenceInput>
                <ReferenceInput label="User Bundle Mapping" source="userBundleMappingId" reference="UserBundleMapping">
                    <SelectInput optionText='id' />
                </ReferenceInput>
                <DateInput source="startDate" />
                <TextInput source="startSlot" />
                <DateInput source="endDate" />
                <TextInput source="endSlot" />
                <TextInput source="leaveTaken" />
                <TextInput source="leaveAllowed" />
            </SimpleForm>
        </Create>
    );
};

export default CookSubscriptionV3Create;